import ProductListPage from "./ProductListPage";

export default ProductListPage;
